import { z } from "zod";
import { OpaqueId } from "./common.js";
/**
 * Recherche unifiée de la carte pilote (loupe) — `GET /networks/{n}/search?q=`.
 * Un seul champ, plusieurs cibles : véhicule (n° de parc), sortie
 * (« F7-14 »), carrefour (code), arrêt (nom). Chaque résultat porte de quoi
 * recentrer la carte (`lat`/`lon`) et, pour un véhicule, de quoi le
 * sélectionner (`journeyId`).
 */
export const SearchHit = z.object({
    kind: z.enum(["vehicle", "junction", "stop"]),
    /** journeyId | junctionId | stopId, selon `kind`. */
    id: z.string(),
    label: z.string(), // « F7-14 · 3120 » | « Bruyères (INEO) » | « Boulingrin »
    sublabel: z.string().nullable(), // ligne + destination, système technique…
    lat: z.number().nullable(),
    lon: z.number().nullable(),
    lineId: OpaqueId.nullable(), // pour un véhicule / un carrefour impacté
});
export const SearchResponse = z.object({
    query: z.string(),
    hits: z.array(SearchHit),
});
//# sourceMappingURL=search.js.map